import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import FileUploader from '~/components/FileUploader';
import { DocumentIcon } from '~/icons';

interface EmptyFolderProps {
  onUploadedFiles: (files: File[]) => Promise<void>;
}

const EmptyFolder: FC<EmptyFolderProps> = ({ onUploadedFiles }) => {
  return (
    <FileUploader
      onChange={onUploadedFiles}
      buttonLabel="Upload Files"
      showFilesList={false}
      clearFilesAfterUpload
      renderContent={() => (
        <Stack alignItems="center" spacing={2}>
          <DocumentIcon style={{ width: '60px', height: '60px', opacity: 0.5 }} />
          <Typography variant="bodySmallStrong" sx={{ opacity: 0.5 }}>
            No Files to display
          </Typography>
        </Stack>
      )}
    />
  );
};

export default EmptyFolder;
